import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { PaginatedRepository } from '../../services/pagination/paginated.repository';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-list-issue',
    templateUrl: './list-issue.component.html',
    styleUrls: ['./list-issue.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListIssueComponent {
  private readonly transloco = inject(TranslocoService);
  @Input() repo!: PaginatedRepository<any>;
  @Input() data!: any[];
  private _message?: string;
  @Input() set message(value: string | null | undefined) { this._message = value ?? undefined; }
  get message(): string { return this._message ?? this.transloco.translate('listIssue.noResourcesFound'); }
}
